import { Link as ChakraLink, type LinkProps as ChakraLinkProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends ChakraLinkProps {}

export default forwardRef<HTMLAnchorElement, Props>((props, ref) => {
  return <ChakraLink ref={ref} {...props} />
})
